var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-layout" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "设置服务能力", name: "setEngineerServc" } },
            [
              _c("swb-query-sort-area", {
                ref: "query_model",
                staticClass: "mb10",
                attrs: {
                  config: _vm.queryConfig,
                  queryOnLoad: false,
                  onConfigReady: _vm.onConfigReady,
                  queryHandler: _vm.queryHandler
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-layout" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "ssuList",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.ssuList, border: "" },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          type: "selection",
                          width: "55"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "servcName",
                          label: "服务名称",
                          align: "left"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "服务项目名称",
                          width: "200",
                          align: "left"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [_vm._v(_vm._s(rows.row.title))]),
                                _vm._v(" "),
                                rows.row.srcMerchantId != null
                                  ? _c("div", { staticClass: "table-tips" })
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "服务来源",
                          width: "150",
                          align: "left"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.srcMerchantType == 2
                                  ? _c("span", [_vm._v("厂家授权")])
                                  : rows.row.srcMerchantType == 4
                                  ? _c("span", [_vm._v("承包授权")])
                                  : _c("span", [_vm._v("自营")])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "服务类型",
                          align: "left",
                          width: "150",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.servcTypeMap[rows.row.type])
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "服务用途",
                          width: "100",
                          align: "left"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      rows.row.comnOnlyFlag
                                        ? "常规服务"
                                        : "维保服务"
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "toDoorFee",
                          label: "上门费(元)",
                          align: "right",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s((rows.row.toDoorFee || 0).toFixed(2))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "workHourFee",
                          label: "参考人工费(元)",
                          align: "right",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      (rows.row.workHourFee || 0).toFixed(2)
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "generallFee",
                          label: "服务费(元)",
                          align: "right",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      (rows.row.generallFee || 0).toFixed(2)
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "block pagination-layout" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-size": _vm.pageSize,
                      "page-sizes": _vm.pageSizes,
                      "current-page": _vm.pageNumber,
                      total: _vm.totalCount,
                      layout: "total, sizes, prev, pager, next, jumper"
                    },
                    on: {
                      "current-change": _vm.handlePageChange,
                      "size-change": _vm.handleSizeChange
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "复制服务能力", name: "copyEngineerServc" } },
            [
              _vm.servicerShopId != null
                ? _c("swb-servicer-engineer-list-for-select", {
                    ref: "swb_servicer_engineer_list_select",
                    attrs: {
                      onlyShowAll: true,
                      servicerShopId: _vm.servicerShopId,
                      ssuIdList: []
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.servicerShopId == null
                ? _c("swb-servicer-xngineer-list-for-select", {
                    ref: "swb_servicer_xngineer_list_select"
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-339dcd52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339dcd52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servc/EngineerSsuListForSelect.vue
// module id = 1975
// module chunks = 1